'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var ipfsUnixfs = require('ipfs-unixfs');

var persist = require('../../utils/persist.js');

var dagPb = require('@ipld/dag-pb');

var rawCodec = require('multiformats/codecs/raw');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n['default'] = e;
  return Object.freeze(n);
}

var dagPb__namespace = /*#__PURE__*/_interopNamespace(dagPb);

var rawCodec__namespace = /*#__PURE__*/_interopNamespace(rawCodec);

function bufferImporter(_x, _x2, _x3) {
  return _bufferImporter.apply(this, arguments);
}

function _bufferImporter() {
  _bufferImporter = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file, block, options) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;

    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context3.prev = 2;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var buffer;
              return _regeneratorRuntime.wrap(function _loop$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      buffer = _step.value;
                      _context2.next = 3;
                      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                        var unixfs, opts;
                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                options.progress(buffer.length, file.path);
                                opts = {
                                  codec: dagPb__namespace,
                                  cidVersion: options.cidVersion,
                                  hasher: options.hasher,
                                  onlyHash: options.onlyHash
                                };

                                if (options.rawLeaves) {
                                  opts.codec = rawCodec__namespace;
                                  opts.cidVersion = 1;
                                } else {
                                  unixfs = new ipfsUnixfs.UnixFS({
                                    type: options.leafType,
                                    data: buffer,
                                    mtime: file.mtime,
                                    mode: file.mode
                                  });
                                  buffer = dagPb__namespace.encode({
                                    Data: unixfs.marshal(),
                                    Links: []
                                  });
                                }

                                _context.next = 5;
                                return persist(buffer, block, opts);

                              case 5:
                                _context.t0 = _context.sent;
                                _context.t1 = unixfs;
                                _context.t2 = buffer.length;
                                return _context.abrupt("return", {
                                  cid: _context.t0,
                                  unixfs: _context.t1,
                                  size: _context.t2
                                });

                              case 9:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      }));

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _loop);
            });
            _iterator = _asyncIterator(file.content);

          case 5:
            _context3.next = 7;
            return _awaitAsyncGenerator(_iterator.next());

          case 7:
            if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
              _context3.next = 12;
              break;
            }

            return _context3.delegateYield(_loop(), "t0", 9);

          case 9:
            _iteratorAbruptCompletion = false;
            _context3.next = 5;
            break;

          case 12:
            _context3.next = 18;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t1 = _context3["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context3.t1;

          case 18:
            _context3.prev = 18;
            _context3.prev = 19;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context3.next = 23;
              break;
            }

            _context3.next = 23;
            return _awaitAsyncGenerator(_iterator.return());

          case 23:
            _context3.prev = 23;

            if (!_didIteratorError) {
              _context3.next = 26;
              break;
            }

            throw _iteratorError;

          case 26:
            return _context3.finish(23);

          case 27:
            return _context3.finish(18);

          case 28:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2, null, [[2, 14, 18, 28], [19,, 23, 27]]);
  }));
  return _bufferImporter.apply(this, arguments);
}

module.exports = bufferImporter;